<template>
  <nav-bar title="拓展审核" />
  <Content :bottom="0" >
    <Loading v-if="showLoading" :isLoading="isLoading" @reload="getList" />
    <ul class="list">
      <list-item v-for="item in list" :item="item" :key="item.id" @click-item="handleItemClick(item)" />
    </ul>
    <loading-more :finished="finished" :showLoadingMore="showLoadingMore" :loadingFail="loadingFail" :list="list" @reload="reload()" />
  </Content>
  <examine-popup ref="examinePopup" />
</template>

<script>
import { ref, computed } from 'vue'
import ListItem from './components/ListItem.vue'
import ExaminePopup from './components/ExaminePopup.vue'
import { useLoadingMore } from '@/hooks/useLoadingMore'
import { getAuditListByPage } from '@/api/chome'
export default {
  name: 'DevelopmentAudit', // 拓展审核
  components: { ListItem, ExaminePopup },
  props: ['companyId'],
  setup (props) {
    const data = useLoadingMore(getAuditListByPage)
    const {
      getList,
      list,
      finished,
      loadingFail,
      pageParams
    } = data

    // 初始化list
    const init = () => {
      list.value = []
      pageParams.page = 1
      pageParams.companyId = computed(() => props.companyId)
      finished.value = false
      loadingFail.value = false
      getList()
    }
    init()

    // 审核
    const examinePopup = ref(null)
    const handleItemClick = (item) => {
      examinePopup.value.showPopup(item, init)
    }
    return { ...data, handleItemClick, examinePopup }
  }
}
</script>

<style lang="scss" scoped>
.list {
  margin: 0px 16px 0 16px;
  font-size: 14px;
  line-height: 22px;
  color: #666;
}
</style>
